<script>
import  {getBaseURL} from "../../url_endpoints";
import {getSignInInfo} from "@/translate";
import {get_UPAYS_auth} from "@/components/hid";
import {upaysAuth} from "authupays";
export default {
  name: "SignIn",
  data() {
    return {
      key:'',
      text:['Type Your Access Key...','Sign In'],
      wait_for_signin: true,
    }
  },
  created() {
    this.emitter.on('change_language', (evt) => {
      //console.log(evt.eventContent)
      if(evt.eventContent === '1') {
        this.text = getSignInInfo(1)
      }else {
        this.text = getSignInInfo(0)
      }
    })
  },
  mounted() {
    window.scroll(0, 0)
    /* clean browser storage*/
    localStorage.removeItem('akey')
    localStorage.removeItem('tkey')
    const language = localStorage.getItem('lang')
    if(!language){
      // nothing to do
    }else {
      this.text = getSignInInfo(Number.parseInt(language))
    }
    this.key = localStorage.getItem('ac_local') ? localStorage.getItem('ac_local') : ''
  },
  computed:{
    counter(){
      return this.key.length
    },
    activateSignIn() {
      return this.key.length === 64
    }
  },
  methods: {
    testNPMCustomers() {
      const localServer = {
        url: 'http://localhost:3000',
        signEndPoint: '/ckeys/auth',
        authEndPoint: '/ckeys/verify',
      }
      const client = {
        businessKey:'13c61de2fd72856a302fcc3b17809c56a87f151aab5e3687c1101637dbadb3ab',
        customerKey:'2080e5bb93ff208dc7c55fe357d0cc7a3703e3149cf8ce8ddd1b0c097d1a5af3',
        auth:{
          username: 'mee is a symbol',
          password: 'just support him'
        }
      }
      //console.log(localServer)
      //console.log(client)

      upaysAuth(client,localServer).then( result => {
        alert(result)//console.log(result)
      }).catch(error => {
        alert(error)//console.log(error)
      })

    },
    resetAC() {
      this.key = ''
    },
    checkKey(){
      let baseURL = getBaseURL()
      let auth = get_UPAYS_auth()
      this.wait_for_signin = !this.wait_for_signin
      fetch(baseURL+'/clients/signin/'+this.key, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Authorization': `Basic ${auth}`,
          'Content-Type': 'application/json'
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
      }).then(response => {
        return response.json()
      }).then( rsp => {
        //console.log('GET executed with success:')
        if(rsp['authorisation']) {
          alert("Authorisation ok, successfully logged in")
          this.emitter.emit('login_process', {'eventContent': 'ok'})
          // save on local client info
          localStorage.setItem('client',JSON.stringify(rsp['config']))
          // save on local customer keys flag
          localStorage.setItem('c_keys',JSON.stringify(rsp['c_keys']))
          /* save DataBase id for this business*/
          localStorage.setItem('bid', JSON.stringify(rsp['bid']))
          this.wait_for_signin = !this.wait_for_signin
          if(rsp['pay']) {
            // go to configurator
            //const config = rsp['config']
            //console.log(config)
            localStorage.setItem('akey',this.key)
            this.$router.push('/configurator')
          } else {
            localStorage.setItem('tkey',this.key)
            this.$router.push('/requesttrial')
          }
        }else {
          alert("Authorisation failed..\n"+rsp['error'])
          const msg = rsp['error']
          if( msg.includes('fee') ){
            this.wait_for_signin = !this.wait_for_signin
            this.$router.push('/')
          }else {
            this.wait_for_signin = !this.wait_for_signin
          }
        }
      }).catch( () => {
        alert("Error : UPAYS Service problem \nPlease try again later....")
        this.wait_for_signin = !this.wait_for_signin
      })
    }
  },
}
</script>

<template>
  <div style="margin-top: 10%;text-align: center;">
    <!--<button class="signbtn" @click="testNPMCustomers">Test CKEY</button>-->
    <div class="input-container">
      <i class="fa fa-shield icon" aria-hidden="true"></i>
      <input class="input-field" type="text" :placeholder="text[0]" maxlength="64" v-model="this.key" >&nbsp;
      <button class="clear"  @click="resetAC">
        <i class="fa fa-close" aria-hidden="true"></i>
      </button>
      &nbsp;<span style="font-size:12px;margin-left:5px">{{counter}}/64</span>
    </div>
    <br><br><br>
    <button v-if="wait_for_signin" class="signbtn" @click="checkKey" :disabled="!activateSignIn">{{ text[1] }}</button>
    <div v-else class="loader"></div>
    <br><br><br><br>
  </div>
</template>
<style scoped>
.input-container {
  display: -ms-flexbox; /* IE10 */
  display: flex;
  margin-left: 23%;
}
.signbtn {
  cursor: pointer;
  margin-top: 30px;
  font-size: 30px;
  padding: 10px 10px;
  border-radius: 8px;
  transform:
      perspective(600px)
      rotateX(60deg)
      scale(0.7);
  box-shadow: 0px 20px 100px #555;
  transition:0.5s ease all;

  &:hover {
    transform:
        rotate(0deg)
        scale(1)
        translateY(10px);
  }
}
/* Style the form icons */
.icon {
  padding: 11px;
  background: #fa755a;
  color: white;
  text-align: center;
  font-size: 24px;
}

/* Style the input fields */
.input-field {
  width: 60%;
  padding: 10px;
  outline: none;
  font-size: 20px;
}
.input-field:focus {
  border: 2px solid dodgerblue;
}
.loader {
  margin: 0px auto;
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #fa755a;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 2s linear infinite;
}
.clear {
  font-size: 20px;
  color: black;
  opacity: 0.6;
  cursor: pointer;
  border: none;
  background-color: transparent;
}
.clear:hover {
  color: crimson;
  opacity: 0.9;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
@media screen and (max-width: 430px) {
  .input-field {
    width: 70%;
    margin-top: 40%;
  }
  .input-container {
    display: block;
    margin-left: 10px;
  }
}

</style>